import { render, staticRenderFns } from "./NomeSito.vue?vue&type=template&id=1137fa0a&scoped=true&"
import script from "./NomeSito.vue?vue&type=script&lang=js&"
export * from "./NomeSito.vue?vue&type=script&lang=js&"
import style0 from "./NomeSito.vue?vue&type=style&index=0&id=1137fa0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1137fa0a",
  null
  
)

export default component.exports